import React, { useState } from "react";
import { Box, styled } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Button from "components/design-system/atoms/Button";

export const TrimText = ({ text, trimLength }) => {
  const [isCollapse, setIsCollapse] = useState(true);

  const truncate = (str, isCollapsed) => {
    return str.length > trimLength && isCollapsed ? str.substring(0, trimLength) + "..." : str;
  };
  const ZeroPaddingButton = styled(Button)(({ theme }) => ({
    padding: 0,
    paddingTop: 4,
    height: 20,
    fontWeight: 400,
    marginLeft: theme.spacing(1),
  }));
  const FlexUnderline = styled("u")(() => ({
    display: "flex",
  }));

  return (
    <Box alignItems={"center"}>
      {text.length > trimLength && (
        <>
          {truncate(text, isCollapse)}
          <ZeroPaddingButton
            dimension="small"
            version="invisible"
            onClick={() => {
              setIsCollapse(!isCollapse);
            }}
          >
            {!isCollapse ? (
              <FlexUnderline>
                Afficher moins{" "}
                <div>
                  <ExpandLess />
                </div>
              </FlexUnderline>
            ) : (
              <FlexUnderline>
                Afficher plus{" "}
                <div>
                  <ExpandMore />
                </div>
              </FlexUnderline>
            )}
          </ZeroPaddingButton>
        </>
      )}
      {text.length < trimLength && <>{text}</>}
    </Box>
  );
};
